import type { TextEdit } from '@cli-types/core-engine/snapshots.js'

export function applyTextEdits(content: string, edits: TextEdit[]): string {
  return edits
    .sort((a, b) => b.start - a.start)
    .reduce(
      (next, edit) => next.slice(0, edit.start) + edit.replacement + next.slice(edit.end),
      content
    )
}
